import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const PROCEDURE_FILE_STATE_QUERY = gql`
  query ProcedureFileStateQuery($procedureId: StrictString!) @skipAudit @engComponent(name: PROCEDURES) {
    procedure(id: $procedureId) {
      ... on ProcedureNode {
        id
        name
        procedureType
        editUrl
        archiveRecord {
          purpose
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

// This "thin" query does not load the flowchart data; it only loads the flowchart ID. This lets us ensure that
// any flowchart version being viewed within this procedure is indeed its child.
export const PROCEDURE_PAGE_THIN_QUERY = gql`
  query ProcedurePageThinQuery($procedureId: StrictString!) @skipAudit @engComponent(name: PROCEDURES) {
    procedure(id: $procedureId) {
      ... on ProcedureNode {
        ...ProcedureGraphQL
        procedureFlowchart {
          id
          ... on ProcedureFlowchartNode {
            id
            latestFlowchartVersion {
              ... on ProcedureFlowchartVersionNode {
                id
                createdAt
              }
              ...InaccessibleInfoGraphQL
            }
            publishedFlowchartVersion {
              ... on ProcedureFlowchartVersionNode {
                id
                createdAt
              }
            }
          }
        }
        processFlowchartConfig {
          id
          currentFlowchartConfigVersion {
            id
          }
        }
        ...PublishingRecordsForVersionHistoryPanelGraphQL
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
  ${getFragmentWrapper('Procedure').fragment}
  ${getFragmentWrapper('PublishingRecordsForVersionHistoryPanel').fragment}
`;

export const PROCEDURE_PAGE_FLOWCHART_VERSION_QUERY = gql`
  query ProcedurePageFlowchartVersionQuery($procedureFlowchartVersionId: StrictString!)
  @skipAudit
  @engComponent(name: PROCEDURES) {
    procedureFlowchartVersion(id: $procedureFlowchartVersionId) {
      ... on ProcedureFlowchartVersionNode {
        id
        createdAt
        nodes {
          ...FullProcedureMethodDefinitionVersionGraphQL
        }
        edges {
          type
          sourceId
          targetId
        }
        procedureFlowchart {
          id
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('FullProcedureMethodDefinitionVersion').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const PROCEDURE_PUBLISHING_RECORDS_FOR_BUTTON = gql`
  query ProcedurePublishingRecordsForButton($procedureId: StrictString!)
  @skipAudit
  @engComponent(name: NOTEBOOK) {
    procedure(id: $procedureId) {
      ... on ProcedureNode {
        id
        ...PublishingRecordsForButtonGraphQL
      }
    }
  }
  ${getFragmentWrapper('PublishingRecordsForButton').fragment}
`;
